import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiHoutenSchipholPage() {
  return (
    <CityAirportTemplate
      city="Houten"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={60.00}
      distance="50 km"
      duration="40-45 minuten"
    />
  );
}
